import { Message } from "@form-validation/plugin-message";

export class CustomMessage extends Message {
  prepareElementContainer(field, element, elements) {
    var container;
    if ("string" === typeof this.opts.container) {
      var selector =
        "#" === this.opts.container.charAt(0)
          ? '[id="'.concat(this.opts.container.substring(1), '"]')
          : this.opts.container;
      container = this.core.getFormElement().querySelector(selector);
    } else {
      container = this.opts.container(field, element);
    }

    // Create <li> element instead of <div>
    var message = document.createElement("li");
    container.appendChild(message);

    // Apply custom classes
    message.classList.add("fv-plugins-message-container");

    if (this.isEnabled) {
      message.classList.add("fv-plugins-message-container--enabled");
    } else {
      message.classList.add("fv-plugins-message-container--disabled");
    }

    this.core.emit("plugins.message.placed", {
      element: element,
      elements: elements,
      field: field,
      messageElement: message
    });

    this.messages.set(element, message);
  }
}
